import * as Util from "./_utilites"

export const foo = (name) => {
  console.log("hello world -conts => " + name )
}

/**
 * Filters with a "2" suffix return the entire data object of the element that passes the filter criteria as opposed to just the Id
 * To do, need to swap out Filters(2) with original filters after new filtering process has been merged into main. 
 */

/**
 * Filters elements in range or array of values (string or text)
 * @function
 * @param {String[]} elements_Ids - element unique ids
 * @param {String[]|Number[]} values - values of each element, should be the same lenght og the element ids array
 * @param {String[]|Number[]} range - range to filter, if numerical min and max, otherwise array of strings
 * @param {Boolean} includeBounds - range to filter 
 * @param {Boolean} keepNull - keep values that are null or otherwise invalid as in range?, eg no number attribute, default true
 * @return {Object}  - array of elements_ids { 0: String[] elements_Ids filtered , 1: String[] }
 */
export function filterByRange(elements_Ids, values, range, includeBounds = true, keepNull = true)
{
  //console.log("filters elements in a range of number of values ");
  var outOfRange = [];

  var inRange = values.reduce(function (inRange, val, index) {
    if (val < range[1] && val > range[0]) inRange.push(elements_Ids[index])
    else if(includeBounds && range.includes(val)) inRange.push(elements_Ids[index])
    else if(keepNull && Util.valueIsInvalid(val)) inRange.push(elements_Ids[index])
    else outOfRange.push(elements_Ids[index]);
    return inRange;
  }, [])

  return { 0: inRange, 1: outOfRange }
}

export function filterByRange2(data, attribute, range, filterEmptyEntries = false, includeBounds = true){
  let inRange = []
  let outOfRange = []
  data.forEach(element => {
    if (element[attribute] > range[0] && element[attribute] < range[1]){
      inRange.push(element)
    }
    else if (includeBounds && range.includes(Number(element[attribute]))){
      inRange.push(element)
    }
    else if (!filterEmptyEntries && Util.valueIsInvalid(element[attribute])){
      inRange.push(element)
    }
    else {
      outOfRange.push(element)
    }
  })
  return {0: inRange, 1: outOfRange}
}

export function filterByValues(elements_Ids, values, samples)
{
  //console.log("filters elements where values are matches the samples");
  var outOfRange = [];

  var inRange = values.reduce(function (inRange, val, index) {
    if (samples.includes(val)) inRange.push(elements_Ids[index])
    else outOfRange.push(elements_Ids[index]);
    return inRange;
  }, [])

  return { 0: inRange, 1: outOfRange }

}

export function filterByValues2(data, values, attribute){
  let inRange = []
  let outRange = []
  let acceptableValues = values.filter(val => val.show == true).map(val => String(val.value))
  data.forEach(element => {
    if (acceptableValues.includes(element[attribute])){
      inRange.push(element)
    } else {
      outRange.push(element)
    }
  })
  return {0: inRange, 1: outRange}
}

/**
 * searches and object array for objects that include values or keys  
 * that start with a specific substring and returns a partitioned list 
 * of object ids for object that include at least on key or value that
 * start with that substring 
 * @param {[Object]} attributes = attribtues to check if substring is in keys or values
 * @param {string} keyword = substring to search for
 * @returns {0:[string], 1:[string]} = list of object Ids that include and dont include substring
 */
export function searchByKeyword(attributes, keyword) {
  let inRange = [];
  let outOfRange = [];
  let search = ('' + keyword).toLowerCase()

  attributes.forEach(e => {
    const isFound = (element) => ('' + element).toLowerCase().startsWith(search);

    let indexK = Object.keys(e).findIndex(isFound);

    let indexV = Object.values(e).findIndex(isFound);

    if (indexK !== -1 || indexV !== -1) inRange.push(e.ellipseId);
    else outOfRange.push(e.ellipseId)

  })

  return {
    0: inRange,
    1: outOfRange
  }

}

export function searchByKeyword2(data, keyword){
  let inRange = [];
  let outOfRange = [];
  let search = ('' + keyword).toLowerCase()

  data.forEach(e => {
    const isFound = (element) => ('' + element).toLowerCase().startsWith(search);                                                                                                                                                                                                                                                 

    let indexK = Object.keys(e).findIndex(isFound);

    let indexV = Object.values(e).findIndex(isFound);

    if (indexK !== -1 || indexV !== -1) inRange.push(e);
    else outOfRange.push(e)

  })

  return {
    0: inRange,
    1: outOfRange
  }
}
/**
 * searches and object array for objects that include a substring and 
 * returns a partitioned list of object ids for object that include and 
 * dont include the substring. 
 * @param {[Object]} attributes = attribtues to check if substring is in keys or values
 * @param {string} substring = substring to search for
 * @returns {0:[string], 1:[string]} = list of object Ids that include and dont include substring
 */
export function searchBySubstring(attributes, substring){
  let inRange = [];
  let outOfRange = [];
  let search = ('' + substring).toLowerCase()

  attributes.forEach(e => {
    const isFound = (element) => ('' + element).toLowerCase().includes(search);

    let inKeys = Object.keys(e).some(isFound);

    let inValues = Object.values(e).some(isFound);

    if (inKeys || inValues) inRange.push(e.ellipseId);
    else outOfRange.push(e.ellipseId)

  })

  return {
    0: inRange,
    1: outOfRange
  }
}